/**
 * Custom tenant / CSV listing markers on the map (admin tooling).
 * When disabled at build time, the UI is hidden and `/data/tenant-properties.json` is never fetched.
 *
 * Enable in `client/.env`:
 *   REACT_APP_ENABLE_TENANT_CUSTOM_LISTINGS=true
 */
export function isTenantCustomListingsFeatureEnabled() {
  return process.env.REACT_APP_ENABLE_TENANT_CUSTOM_LISTINGS === 'true';
}
